import { render, staticRenderFns } from "./DlgEventTemplateCopyFrom.vue?vue&type=template&id=3f23ec58&scoped=true"
import script from "./DlgEventTemplateCopyFrom.vue?vue&type=script&lang=ts"
export * from "./DlgEventTemplateCopyFrom.vue?vue&type=script&lang=ts"
import style0 from "./DlgEventTemplateCopyFrom.vue?vue&type=style&index=0&id=3f23ec58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f23ec58",
  null
  
)

export default component.exports